(function(){
  var FORMSPREE = 'https://formspree.io/f/mlgzppgd';
  var reEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function post(data){
    var body = new URLSearchParams();
    Object.keys(data).forEach(function(k){ body.append(k, data[k]); });
    try { return fetch(FORMSPREE, { method:'POST', headers:{ 'Accept':'application/json' }, body:body }); }
    catch(e){ return Promise.resolve(); }
  }

  /* ---------- SPLASH ---------- */
  var splash = document.getElementById('splash');
  if (splash) {
    if (sessionStorage.getItem('sbt_entered')) {
      splash.parentNode && splash.parentNode.removeChild(splash);
    } else {
      document.documentElement.classList.add('splash-locked');
      document.body.classList.add('splash-locked');
      var enterBtn = document.getElementById('enterBtn');
      function doEnter(e){
        if (e) e.preventDefault();
        sessionStorage.setItem('sbt_entered','1');
        document.documentElement.classList.remove('splash-locked');
        document.body.classList.remove('splash-locked');
        window.scrollTo(0,0);
        splash.classList.add('hidden');
        setTimeout(function(){ if (splash) splash.style.display='none'; }, 1300);
      }
      if (enterBtn) enterBtn.addEventListener('click', doEnter);

      var sEmail=document.getElementById('splash-email'), sEmailBtn=document.getElementById('splash-email-btn');
      var sPhone=document.getElementById('splash-phone'), sPhoneBtn=document.getElementById('splash-phone-btn');
      var sStat=document.getElementById('splash-form-status');
      function sStatus(t, ok){ if(sStat){ sStat.textContent=t; sStat.style.color= ok ? '#2d6a4f' : '#b3261e'; } }
      if (sEmailBtn) sEmailBtn.addEventListener('click', function(){
        var v=(sEmail.value||'').trim();
        if(!reEmail.test(v)){ sStatus('Enter a valid email', false); sEmail.focus(); return; }
        post({ type:'newsletter_signup', email:v, source:'splash_screen' });
        sStatus("You're in — use code WELCOME20 ✓", true);
      });
      if (sPhoneBtn) sPhoneBtn.addEventListener('click', function(){
        var v=(sPhone.value||'').trim();
        if(!v){ sStatus('Enter a phone number', false); sPhone.focus(); return; }
        post({ type:'sms_signup', phone:v, source:'splash_screen' });
        sStatus("Added — we'll text you drops ✓", true);
      });
    }
  }

  /* ---------- WELCOME 20% POPUP ---------- */
  var pop = document.getElementById('welcome-pop');
  if (pop && !localStorage.getItem('sbt_welcome_pop')) {
    var opened=false;
    function openPop(){
      if(opened) return;
      if(document.body.classList.contains('splash-locked')) return;
      opened=true;
      localStorage.setItem('sbt_welcome_pop','1');
      pop.classList.add('open');
      pop.setAttribute('aria-hidden','false');
    }
    function closePop(){ pop.classList.remove('open'); pop.setAttribute('aria-hidden','true'); }

    var targets=['#brand-product-grid','.sbt-grid','.coll-grid','#category-product-grid'];
    var watch=null;
    for(var i=0;i<targets.length;i++){ watch=document.querySelector(targets[i]); if(watch) break; }
    if('IntersectionObserver' in window && watch){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ openPop(); io.disconnect(); } });
      }, { threshold:0.2 });
      io.observe(watch);
    } else {
      window.addEventListener('scroll', function(){ if(window.scrollY>600) openPop(); }, { passive:true });
    }

    var closeBtn=document.getElementById('welcome-pop-close'); if(closeBtn) closeBtn.addEventListener('click', closePop);
    var backdrop=pop.querySelector('.welcome-pop__backdrop'); if(backdrop) backdrop.addEventListener('click', closePop);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closePop(); });

    var wBtn=document.getElementById('welcome-pop-btn'), wEmail=document.getElementById('welcome-pop-email'), wPhone=document.getElementById('welcome-pop-phone');
    var wStat=document.getElementById('welcome-pop-status'), wForm=document.getElementById('welcome-pop-form'), wSucc=document.getElementById('welcome-pop-success');
    if(wBtn) wBtn.addEventListener('click', function(){
      var v=(wEmail.value||'').trim();
      if(!reEmail.test(v)){ if(wStat){ wStat.textContent='Enter a valid email'; wStat.className='welcome-pop__status err'; } wEmail.focus(); return; }
      post({ type:'newsletter_signup', email:v, phone:(wPhone.value||'').trim(), source:'scroll_popup_welcome20' });
      if(wForm) wForm.style.display='none';
      if(wSucc) wSucc.style.display='block';
    });
    var copyBtn=document.getElementById('welcome-pop-copy');
    if(copyBtn) copyBtn.addEventListener('click', function(){
      try { navigator.clipboard.writeText('WELCOME20'); } catch(e){}
      var orig=copyBtn.textContent; copyBtn.textContent='Copied ✓';
      setTimeout(function(){ copyBtn.textContent=orig; }, 1500);
    });
  }
})();
